<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LiveInputValidator',

  props: {
    url: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    param: {
      type: String,
      default: 'value',
    },
    validatingMessage: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      slotChild: null,
      _timer: null,
    };
  },

  provide() {
    return {
      __livRegister: (vm) => {
        this.slotChild = vm;
      },
    };
  },

  watch: {
    value(val) {
      clearTimeout(this._timer);

      if (!String(val).trim()) {
        this.slotChild?.feedback(null, '');
        return;
      }

      if (this.validatingMessage) {
        this.slotChild?.feedback('validating', this.validatingMessage);
      }

      this._timer = setTimeout(async () => {
        try {
          const key = this.param;
          const { data } = await window.axios.post(this.url, { [key]: val });
          this.slotChild?.feedback('success', data.message || '');
        } catch (error) {
          const message = error?.response?.data?.message || '';
          this.slotChild?.feedback('error', message);
        }
      }, 500);
    },
  },

  beforeUnmount() {
    clearTimeout(this._timer);
  },
};
</script>
